
import { defineComponent, computed } from "vue";
import { store } from "@/store"

export default defineComponent({
  name: "LoadingScreen",
  setup() {
    const appIsLoading = computed<boolean>(() => store.getters.appIsLoading);

    return {
      appIsLoading,
    };
  },
});
